





















































































import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import DictServices, { DictDto } from '@/services/dict';
import { mixins } from 'vue-class-component';
import { Vue, Component, Watch } from 'vue-property-decorator';
@Component
export default class DictDetail extends mixins(DictMixin, MenuMixin) {
  visible = false;

  columns = [
    { title: '字典名称', dataIndex: 'dictName' },
    { title: '条目名称', dataIndex: 'dictItemName' },
    { title: '引用对象类型', dataIndex: 'refType', customRender: (type: number) => (type === 1 ? '指标' : '决策') },
    { title: '引用对象名称', dataIndex: 'refName' }
  ];
  drawerTable = [];

  dictSrv = new DictServices();

  edit = false;
  id: any = 0;
  info: DictDto = {};
  dictItemDefList = [];

  async created() {
    this.id = this.$route.query.id;
  }

  async getRef() {
    this.visible = true;
    let res = await this.dictSrv.getRefList({ dictCode_eq: this.info.dictCode, page: 1, limit: 1000 });
    this.drawerTable = res.records;
  }

  @Watch('$route')
  onRouteChange() {
    this.id = this.$route.query.id;
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    if (!this.id || this.$route.path != '/decision/dict/detail') return false;
    this.spinning = true;
    let res = await this.dictSrv.getInfo(this.id);
    this.spinning = false;
    if (!res) return false;
    this.info = res.dictDef;
    this.dictItemDefList = res.dictItemDefList;
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
